import { Component, OnInit, Input } from '@angular/core';
import { MedicalAppointmentModel, Appointment } from '../../models/medical-appointment.model';

@Component({
  selector: 'future-appointments',
  templateUrl: './future-appointments.component.html',
  styleUrls: ['./future-appointments.component.scss']
})
export class FutureAppointmentsComponent implements OnInit {
    @Input() appointment: MedicalAppointmentModel;

    futureItems: Appointment[];
    currentDateTime: Date;

    constructor() { }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.currentDateTime = new Date();

        this.futureItems = this.appointment.appointment.filter(x => {
            return new Date(x.appointmentDateTime) > this.currentDateTime;
        }).sort((a, b) => {
            if (a.appointmentDateTime < b.appointmentDateTime) { return -1; }
            if (a.appointmentDateTime > b.appointmentDateTime) { return 1; }
            return 0;
        });

    }

}
